import type { AuthenticatedUser } from './AuthContext';

/**
 * iter-53: shared destination resolver for an authenticated user.
 *
 * Used by:
 * - SplashRoute (skip onboarding chain if a returning user already has
 *   a valid session)
 * - LoginRoute (auto-redirect if someone navigates to /auth/login while
 *   already authenticated, and after a fresh OTP verify)
 *
 * Mirrors the routing logic in RequireOnboardingComplete + RequireRole so
 * the entry-point matches what the guards would do once a screen renders.
 */
export function computeAuthenticatedLanding(user: AuthenticatedUser): string {
  switch (user.onboarding_state) {
    case 'language':
      return '/language';
    case 'profile':
    case 'role':
      return '/profile/complete';
    case 'health':
      // iter-35: the backend marks volunteer onboarding 'health' as the
      // terminal step for that role, so a volunteer here goes straight
      // to their shell. Pilgrims still need the health-card wizard.
      return user.role === 'volunteer' ? '/volunteer' : '/health/onboarding';
    case 'complete':
    default:
      return user.role === 'volunteer' ? '/volunteer' : '/app/home';
  }
}
